import styled from "styled-components";
import IntroBackground from "../../resources/images/background/intro1.jpg";
import UseBreakpoints from "../../components/hooks/ui/UseBreakpoints";
import PageTemplate from "../../components/ui/common/template/PageTemplate";
const Intro = () => {
  const breakpoints = UseBreakpoints();
  return (
    <PageTemplate
      title="인사말"
      image={IntroBackground}
      phrase={"관세법인을 넘어, 글로벌 관세무역 인텔리전스 기업으로"}
      large
      aone
    >
      <Div>
        <StyledArticle breakpoints={breakpoints}>
          <SubText>안녕하십니까?</SubText>
          <p>
            관세법인 에이원은 수출입 통관, 관세환급, 수입요건 및 검역, FTA, AEO
            컨설팅, 세관 심사·조사 대응 및 행정쟁송 등 기업의 관세무역 전반에
            걸쳐 체계적이고 전문적인 서비스를 제공합니다.
          </p>
          <p>
            에이원은 자체 개발한 관세무역 플랫폼 ASCP(AONE Smart Customs
            Platform)를 통해 신속하고 정확한 통관 서비스를 제공하고 있습니다.
            통관 자동화 시스템을 활용해 고객사의 품목 마스터, 단가 및 FTA 원산지
            이력을 체계적으로 관리하며, AI 기반 리스크 진단과 법률·리서치
            시스템을 통해 통관 전·후에 발생할 수 있는 관세 리스크를 선제적으로
            식별하고 관리합니다.
          </p>
          <p>
            또한 2010년 AEO 공인을 받고 2013년부터 AA등급을 유지해 온 경험과
            다년간 축적한 AEO 인증 컨설팅 노하우를 바탕으로 기업의 수출입 안전관리 체계 구축과
            인증 취득을 지원하고 있습니다. 아울러 미국, 중국, EU 등 주요 FTA
            체결국의 관세 전문가들과 구축한 글로벌 네트워크를 바탕으로 해외
            관세행정 이슈에도 신속하게 대응합니다.
          </p>
          <p>
            법인심사 및 종합심사, 관세·외환 조사 등에는 세관 경력자와 관세 분야
            전문 인력으로 구성된 컨설팅 그룹이 참여합니다. 축적된 실무 경험과
            전문성을 바탕으로 고객사의 상황에 맞는 대응 전략을 수립하고 책임감
            있는 전문 서비스를 제공합니다.
          </p>
          <p>
            에이원은 고객 만족을 최우선 가치로 삼고, 고객관리 전담 조직과
            고객사별 CM(Client Management) 관세사 운영을 통해 지속적이고 밀착된
            고객관리 서비스를 제공하고 있습니다. 이를 통해 통관 전·후의 관세
            리스크를 최소화하고 고객사의 안정적인 무역 활동을 지원하며, 오랜
            기간 신뢰받는 파트너로 함께해 왔습니다.
          </p>
          <p>
            이제 에이원은 25년간 축적한 전문적인 판단 노하우와 데이터를 플랫폼에
            담아, 관세법인을 넘어 AI 기반 글로벌 관세무역 인텔리전스 기업으로
            도약하고자 합니다.
          </p>
          <p>
            AI가 리스크를 찾아내고 전문가가 판단과 책임을 더하는 방식으로,
            관세업무의 시작과 끝은 물론 고객의 공급망 전반까지 지원하는 Customs
            Solution Partner, 에이원이 새로운 관세무역 서비스의 미래를
            열어갑니다.
          </p>
          <LastText>관세법인 에이원 일동</LastText>
        </StyledArticle>
      </Div>
    </PageTemplate>
  );
};
export default Intro;

const Div = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 4.5rem;
`;
const StyledArticle = styled.article`
  max-width: 50rem;
  & p {
    text-align: justify;
    font-size: clamp(1.02rem, 1.4vw, 1.12rem);
    margin: 1.75rem 0;
    line-height: 1.95;
    color: ${({ theme }) => theme.colors.monotone.dark};
  }
`;

const SubText = styled.div`
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  color: ${({ theme }) => theme.colors.dark};
  padding-bottom: 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
`;

const LastText = styled.div`
  margin-top: 2.5rem;
  font-size: 1.2rem;
  font-weight: 800;
  text-align: right;
  color: ${({ theme }) => theme.colors.dark};
  &:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 2rem;
    height: 2px;
    margin-right: 0.75rem;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;
